// extracted by mini-css-extract-plugin
export default {"appLayout":"layout_appLayout__Fgl1C","mainContent":"layout_mainContent__w3jwb"};